import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { axiosInstance, initializeMock } from './hooks/useAxios'
import { AuthStore } from './store/authStore'
import { delay } from 'lodash-es'
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-toastify/dist/ReactToastify.css'
import './style/index.scss'
import 'swiper/css'
import 'swiper/css/navigation'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { getPublicConfig } from './api/getPublicConfig'
import { ConfigStore } from './store/configStore'
import { getConfig } from './api/getConfig'

dayjs.locale('ru')
dayjs.extend(customParseFormat)

gsap.registerPlugin(ScrollTrigger)

void (async () => {
  await initializeMock()

  await Promise.all([AuthStore.checkAuth(), ConfigStore.getConfig('public')])

  if (AuthStore.isUserAuthenticated) {
    await ConfigStore.getConfig('private')
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  )

  root.render(<App />)

  const preloader = document.getElementById('preloader')
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const { startDate } = window
  const diff = new Date().getTime() - startDate.getTime()
  let _delay = 1000 - diff

  if (_delay < 0) {
    _delay = 0
  }

  delay(() => {
    preloader?.remove()
  }, _delay)
})()
